/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable indent */
import { getValue } from 'globals/utils';
import React, { Component, Suspense, lazy } from 'react';
import { WithRouterHooks } from 'withFunctionHooks';

class ChatBot extends Component {
     constructor(props) {
          super(props);
          const { match } = this.props;
          this.state = {isLoggedIn:false,chatBotUrl:"" };
          this.checkIfLoggedIn();
     }

     checkIfLoggedIn = () => {
          getValue().then(async (payloadData) => {
               if (payloadData && payloadData.isloggedin && payloadData.chatBotUrl && payloadData.chatBotUrl!="") {
                    this.setState({chatBotUrl: payloadData.chatBotUrl ,isLoggedIn:true});
               } else {
                    this.setState({isLoggedIn:false});
               }
          });
     }

     render = () => {
          return (<>
               {this.state.isLoggedIn && <button className="chatbot-button" onClick={()=>{
                    window.open(
                         this.state.chatBotUrl, "_blank");
               }}>
                    <img src="/images/chatbot.png" alt="Chatbot" />
               </button>}
          </>)
     }
}

export default WithRouterHooks(ChatBot);
